module.exports = __webpack_public_path__ + "static/img/vegetables.4b41b4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/vegetables.png
// module id = sw5o
// module chunks = 1